export default "__VITE_ASSET__Yf1ZBoJc__"